import { render } from "./ServiceFlap.vue?vue&type=template&id=988d2ade"
import script from "./ServiceFlap.vue?vue&type=script&lang=js"
export * from "./ServiceFlap.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__